import { render, staticRenderFns } from "./BatchForm.vue?vue&type=template&id=481f0632&scoped=true&"
import script from "./BatchForm.vue?vue&type=script&lang=ts&"
export * from "./BatchForm.vue?vue&type=script&lang=ts&"
import style0 from "./BatchForm.vue?vue&type=style&index=0&id=481f0632&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481f0632",
  null
  
)

export default component.exports